<template>
    <div class="flex items-center space-x-2">
        <div class="flex flex-col" v-if="shipment.pickup_tracking">
            <span class="text-gray-600 text-[8px]">Recolecta</span>
            <span
                class="w-fit text-primary-100 bg-primary-800 text-[12px] font-semibold mr-2 px-2.5 py-0.5 rounded uppercase whitespace-nowrap"
            >
                {{ proveedores[shipment.pickup_proveedor_id] }}
            </span>
            <span>{{ shipment.pickup_tracking }}</span>
        </div>
        <Icon v-if="shipment.pickup2_tracking" size="15">
            <ArrowRight />
        </Icon>
        <div v-if="shipment.pickup2_tracking" class="flex flex-col">
            <span class="text-gray-600 text-[8px]">2da recolecta</span>
            <span
                class="w-fit text-primary-100 bg-primary-800 text-[12px] font-semibold mr-2 px-2.5 py-0.5 rounded uppercase whitespace-nowrap"
            >
                {{ proveedores[shipment.pickup2_proveedor_id] }}</span
            >
            <span>{{ shipment.pickup2_tracking }}</span>
        </div>
        <Icon v-if="shipment.pickup_tracking" size="15">
            <ArrowRight />
        </Icon>
        <div class="flex flex-col">
            <span class="text-gray-600 text-[8px]">Entrega</span>
            <span
                class="w-fit text-primary-100 bg-primary-800 text-[12px] font-semibold mr-2 px-2.5 py-0.5 rounded uppercase whitespace-nowrap"
            >
                {{ proveedores[shipment.proveedor_id] }}</span
            >
            <span>{{ shipment.tracking }}</span>
        </div>
    </div>
</template>

<script>
import { Icon } from "@vicons/utils";
import { ArrowRight } from "@vicons/fa";
export default {
    name: "TrackingColumn",
    components: {
        Icon,
        ArrowRight,
    },
    props: {
        shipment: Object,
        proveedores: Object,
    },
};
</script>
